module.exports = __webpack_public_path__ + "static/media/Foggia.31901909.png";